<template>
  <div>
    <cac-page
      v-if="hasAdvocate"
      has-sidebar>
      <fixed-sidebar slot="pre-content">
        <cac-page-header
          slot="header"
          :title="$t('cac.app.voter_information')"
        />

        <sidebar-content
          v-if="!loading"
          :state-name="stateName"
          :sidebar-links="sidebarLinks"
          :sos-information="sosInformation"
          class="d-none d-md-block"
        />
        <spinner v-else/>
      </fixed-sidebar>

      <div
        v-if="!loading"
        class="voter-info-content">
        <registration-status
          :registered="registrationStatus.registered"
          :address="registrationStatus.address"
        />

        <upcoming-elections :elections="elections" />

        <election-news-updates
          v-if="showElectionNewsUpdates"
          :state-name="stateName"
          :news-updates="electionNewsUpdates"
        />
        
        <vote-by-mail
          v-if="showVoteByMail"
          :vote-by-mail-content="voteByMail"
        />
        
        <!-- <polling-locations
          v-else-if="hasPollingLocations"
          :locations="locations"
        /> -->
      </div>
      <spinner v-else/>

      <sidebar-content
        :state-name="stateName"
        :sidebar-links="sidebarLinks"
        :sos-information="sosInformation"
        class="d-md-none"
      />
    </cac-page>
    <voter-information-banner v-else/>
  </div>
</template>

<script>
import { isEmpty as _isEmpty } from "lodash";
import { mapGetters, mapState } from "vuex";
import AdvocateActions from "Constants/campaign/civicactioncenter/advocateActions";
import STATE from "Constants/campaign/civicactioncenter/state";
import Icon from "StyleguideComponents/Icon.vue";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import FixedSidebar from "CivicActionCenterComponents/shared/FixedSidebar.vue";
import Spinner from "CivicActionCenterComponents/utilities/Spinner.vue";
import { CHECK } from "Constants/styleguide/iconNames";

import ElectionNewsUpdates from "CivicActionCenterComponents/sections/VoterInformation/ElectionNewsUpdates.vue";
// import PollingLocations from "CivicActionCenterComponents/sections/VoterInformation/PollingLocations.vue";
import VoteByMail from "CivicActionCenterComponents/sections/VoterInformation/VoteByMail.vue";
import RegistrationStatus from "CivicActionCenterComponents/sections/VoterInformation/RegistrationStatus.vue";
import SidebarContent from "CivicActionCenterComponents/sections/VoterInformation/SidebarContent.vue";
import UpcomingElections from "CivicActionCenterComponents/sections/VoterInformation/UpcomingElections.vue";
import VoterInformationBanner from "CivicActionCenterComponents/sections/VoterInformation/VoterInformationBanner.vue";

const hasAdvocate = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;
const selectedLanguageContext = `${STATE.SCOPE_CAC}/${STATE.SELECTED_LANGUAGE}`;

export default {
  name: "VoterInformation",
  components: {
    CacPage,
    CacPageHeader,
    FixedSidebar,
    Icon,
    ElectionNewsUpdates,
    // PollingLocations,
    VoteByMail,
    RegistrationStatus,
    SidebarContent,
    UpcomingElections,
    Spinner,
    VoterInformationBanner
  },
  inject: {
    apiHelper: { from: "apiHelper" }
  },
  data() {
    return {
      elections: [],
      locations: [],
      sidebarLinks: [],
      sosInformation: {},
      stateName: "",
      registrationStatus: {
        registered: false,
        address: ""
      },
      loading: false,
      checkIcon: CHECK
    };
  },
  computed: {
    ...mapState(STATE.SCOPE_CAC, {
      voterInformation: STATE.VOTER_INFORMATION
    }),
    ...mapGetters({
      advocateRecord: `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_RECORD}`,
      selectedLanguage: selectedLanguageContext,
      hasAdvocate
    }),
    hasPollingLocations() {
      return this.locations.length > 0;
    },
    isEnglishLanguageSelected() {
      return this.selectedLanguage === "en";
    },
    electionNewsUpdates() {
      return this.voterInformation.stateRegistrationInfo.electionNewsUpdates;
    },
    showElectionNewsUpdates() {
      return (
        this.isEnglishLanguageSelected &&
        typeof this.electionNewsUpdates === "string" &&
        this.electionNewsUpdates.length > 0
      );
    },
    voteByMail() {
      return this.voterInformation.stateRegistrationInfo.voteByMail;
    },
    showVoteByMail() {
      return typeof this.voteByMail === "string" && this.voteByMail.length > 0;
    }
  },
  watch: {
    hasAdvocate: "fetchVoterInformation",
    voterInformation: "handleVoterInformation"
  },
  activated() {
    this.fetchVoterInformation();
    this.handleVoterInformation();
  },
  methods: {
    isLastIndex(index) {
      return index < this.voterInfoOptions.length - 1;
    },
    fetchVoterInformation() {
      if (
        !this.hasAdvocate ||
        !_isEmpty(this.voterInformation.registrationStatus)
      ) {
        return;
      }
      this.apiHelper.getVoterInformation(this.advocateRecord);
    },
    async handleVoterInformation() {
      if (_isEmpty(this.voterInformation.registrationStatus)) {
        this.loading = true;
        return;
      }

      this.loading = false;

      ({
        elections: this.elections,
        locations: this.locations,
        stateName: this.stateName,
        sidebarLinks: this.sidebarLinks,
        sosInformation: this.sosInformation,
        registrationStatus: this.registrationStatus
      } = this.voterInformation);

      await this.apiHelper.trackAdvocateAction(
        this.advocateRecord,
        AdvocateActions.VOTING_INFORMATION
      );
    }
  }
};
</script>
